type OtpResendPromptProps = {
  prompt: string;
  actionLabel: string;
  busyLabel: string;
  onResend: () => void;
  busy?: boolean;
  disabled?: boolean;
  sentMessage?: string | null;
};

export function OtpResendPrompt({
  prompt,
  actionLabel,
  busyLabel,
  onResend,
  busy = false,
  disabled = false,
  sentMessage,
}: OtpResendPromptProps) {
  return (
    <div className="otp-resend">
      <p className="otp-resend-text">
        {prompt}{' '}
        <button
          type="button"
          className="otp-resend-action"
          disabled={busy || disabled}
          onClick={onResend}
        >
          {busy ? busyLabel : actionLabel}
        </button>
      </p>
      {sentMessage && <p className="note">{sentMessage}</p>}
    </div>
  );
}
